/* eslint-disable react/prop-types */
const BioName = ({ name = '' }) => <h3>{name}</h3>;

export default BioName;
